import { render, staticRenderFns } from "./DetailProductComponent.vue?vue&type=template&id=52e2f06a&scoped=true&"
import script from "./DetailProductComponent.vue?vue&type=script&lang=js&"
export * from "./DetailProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductComponent.vue?vue&type=style&index=0&id=52e2f06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2f06a",
  null
  
)

export default component.exports